package com.mrpowergamerbr.puppydough.webrune.packets

import kotlinx.serialization.Serializable

@Serializable
sealed class Boxed2PlayPacket {
    @Serializable
    data object RunnerExit : Boxed2PlayPacket()

    @Serializable
    data object RunnerStarted : Boxed2PlayPacket()

    @Serializable
    data object RunnerLoading : Boxed2PlayPacket()
}